/* eslint-disable no-extra-parens */
/* eslint-disable indent */
/* eslint-disable max-lines-per-function */
import 'extensions/ui-components/x-quantity';
import {imageFallback} from 'extensions/ui-directives';
import {defineCustomElement, formatPrice} from 'extensions/ui-utils';
import {LitElement, html, nothing} from 'lit';
import stylesheet from './x-rma-summary-product.scss?as=stylesheet';

export class RMASummaryProduct extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			category: {
				type: String
			},
			imageUrl: {
				attribute: 'image-url',
				type: String
			},
			itemCondition: {
				attribute: 'item-condition',
				type: String
			},
			price: {
				type: Number
			},
			quantity: {
				type: Number
			},
			reason: {
				type: String
			},
			serialNumber: {
				attribute: 'serial-number',
				type: String
			},
			sku: {
				type: String
			},
			uploadData: {
				type: Array
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.category = '';

		/**
		 * @type {string}
		 */
		this.imageUrl = '';

		/**
		 * @type {string}
		 */
		this.itemCondition = '';

		/**
		 * @type {number}
		 */
		this.price = 0;

		/**
		 * @type {number}
		 */
		this.quantity = 1;

		/**
		 * @type {string}
		 */
		this.reason = '';

		/**
		 * @type {string}
		 */
		this.serialNumber = '';

		/**
		 * @type {string}
		 */
		this.sku = '';

		/**
		 * @type {import('extensions/rma/types').RMAUploadData[]}
		 */
		this.uploadData = [];
	}

	renderAttribute (prompt, value) {
		if (!value || value.length === 0) {
			return nothing;
		}

		return html`
			<div class="attribute">
				<div class="attribute-prompt">${prompt}:</div>
				${
					Array.isArray(value)
						? html`<div>${value.map(_value => html`<div>${_value}</div>`)}</div>`
						: value
				}
			</div>
		`;
	}

	render () {
		return html`
			<div class="container">
				<div class="product-image">
					<img src="${this.imageUrl}" alt="${this.sku} image" loading="lazy" ${imageFallback(window.mivaJS.Image_Not_Found_Grid)} />
				</div>

				<div class="product-info">
					<div class="product-name">
						<div class="product-category">${this.category}</div>
						<div class="product-sku">${this.sku}</div>
					</div>

					<div class="attributes">
						${this.renderAttribute('Serial Number', this.serialNumber)}

						${this.renderAttribute('Reason for Return', this.reason)}

						${this.renderAttribute('Photos', this.uploadData?.map(uploadData => uploadData.name))}

						${this.renderAttribute('Item Condition', this.itemCondition)}
					</div>
				</div>

				<div class="product-price">
					${formatPrice(this.price * -1)}
				</div>
			</div>
		`;
	}
};

defineCustomElement('x-rma-summary-product', RMASummaryProduct);
